<template>
  <div class="checkboxAsync">
    <b-tooltip
      :label="$t('general.composants.checkboxAsync.tooltipInfo')"
      :active="!error"
      :position="tooltipPosition"
      class="absolute-center">
      <b-tooltip
        :label="labelError"
        :active="error"
        type="is-danger">
        <b-checkbox
          :value="checkboxValue"
          @input="majValueAsync">
        </b-checkbox>
      </b-tooltip>
    </b-tooltip>
    <qd-loading
      :active="isLoading"
      :is-full-page="false"
      :can-cancel="true"/>
  </div>
</template>
<script>
import validationGeneral from '@/services/validation/validation';

export default {
  name: 'CheckboxAsync',
  props: {
    value: {
      type: Boolean,
      required: false,
    },
    id: {
      type: String,
      required: true,
    },
    maj: {
      type: Function,
      required: true,
    },
    tooltipPosition: {
      type: String,
      default: 'is-top',
    },
  },
  data() {
    return {
      messages: [],
      messagesChampsVide: [],
      champsVide: [],
      error: false,
      isLoading: false,
      labelError: this.$t('general.composants.checkboxAsync.tooltipError'),
    };
  },
  computed: {
    checkboxValue: {
      get() {
        return this.value;
      },
      set(newValue) {
        this.$emit('input', newValue);
      },
    },
  },
  methods: {
    async majValueAsync(value) {
      if (!this.id) return;
      this.messages = [];
      this.messagesChampsVide = [];
      this.champsVide = [];
      this.error = false;
      this.isLoading = true;
      try {
        await this.maj(this.id, value);
        this.checkboxValue = value;
        this.$emit('refresh');
      } catch (e) {
        if (e.response && e.response.data.error) {
          validationGeneral(this.$i18n, e.response, this.champsVide,
            this.messages, this.messagesChampsVide);
          if (this.messages.length > 0) {
            this.labelError = this.messages
              .map(msg => {
                return this.$t(
                  msg.message,
                  msg.parametres ? msg.parametres : {});
              })
              .join(', ');
          } else {
            this.labelError = this.$t('general.composants.checkboxAsync.tooltipError');
          }
        }
        this.error = true;
        this.checkboxValue = !value;
        throw e;
      } finally {
        this.isLoading = false;
      }
    },
  },
};
</script>
